import { Link, useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { ListChecks } from "lucide-react";
import { useProjectList } from "@/contexts/ProjectListContext";

export default function ProjectListFloatingButton() {
  const { count } = useProjectList();
  const { pathname } = useLocation();

  // Don't show on the build-project page itself, admin, or auth pages
  const hidden =
    pathname.startsWith("/build-project") ||
    pathname.startsWith("/admin") ||
    pathname.startsWith("/login") ||
    pathname.startsWith("/register") ||
    pathname.startsWith("/project-f") ||
    pathname.startsWith("/project-d");

  return (
    <AnimatePresence>
      {!hidden && count > 0 && (
        <motion.div
          initial={{ opacity: 0, y: 16, scale: 0.9 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 16, scale: 0.9 }}
          transition={{ duration: 0.25 }}
          className="fixed bottom-5 left-5 z-[60]"
        >
          <Link
            to="/build-project"
            className="group inline-flex items-center gap-3 pl-4 pr-5 py-3 rounded-full bg-gradient-to-r from-primary to-accent text-primary-foreground shadow-2xl shadow-primary/40 hover:scale-105 transition-transform"
          >
            <span className="relative">
              <ListChecks className="h-5 w-5" />
              <span className="absolute -top-2 -right-2 min-w-[18px] h-[18px] px-1 rounded-full bg-background text-foreground text-[10px] font-bold flex items-center justify-center border border-primary/40">
                {count}
              </span>
            </span>
            <span className="text-sm font-semibold">Review Project List</span>
          </Link>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
